import PhotoSwipe from 'photoswipe';
import PhotoSwipeLightbox from 'photoswipe-lightbox';

/**
 * @async
 * @function popupPhotoSwipeLightbox
 * @param {Object} params - Parameters for the lightbox.
 * @param {Array<Object>} params.dataSource - Array of image objects for the gallery.
 *   Each object should have the following structure:
 *     {
 *       src: {string},   // Image URL
 *       width: {number}, // Image width
 *       height: {number}, // Image height
 *     }
 * @param {number} [params.index=0] - The index of the image to open initially.
 * @param {Object} [params.options={}] - Additional PhotoSwipe options.
 * @param {boolean} [params.isShowDot=true] - Whether to show bullets for navigation.
 * @returns {PhotoSwipeLightbox}
 */
function photoswipe({
  dataSource = [],
  index = 0,
  options = {},
  isShowDot = true,
}) {
  const closeSVG = `<div class="icon-close-wrapper"><svg class="icon icon-close"><use xlink:href="#icon-close"></use></svg></div>`;
  const lightbox = new PhotoSwipeLightbox({
    dataSource,
    arrowPrevSVG: '',
    arrowNextSVG: '',
    closeSVG,
    zoom: false,
    clickToCloseNonZoomable: false,
    bgClickAction: false,
    closeOnVerticalDrag: false,
    allowPanToNext: false,
    pinchToClose: false,
    bgOpacity: 1,
    mainClass: 'sl-photoswipe',
    padding: { top: 30, bottom: 30 },
    loop: false,
    ...options,
    pswpModule: PhotoSwipe,
  });

  // register custom UI bullets indicator
  if (isShowDot) {
    lightbox.on('uiRegister', () => registerBulletsIndicator(lightbox));
  }
  lightbox.init();
  lightbox.loadAndOpen(index);
  return lightbox;
}

function registerBulletsIndicator(lightbox) {
  lightbox.pswp.ui.registerElement({
    name: 'bulletsIndicator',
    className: 'photoswipe-dots',
    appendTo: 'wrapper',
    onInit: (el, pswp) => {
      const bullets = Array.from({ length: pswp.getNumItems() }, (_, index) => {
        const bullet = document.createElement('div');
        bullet.className = 'photoswipe-dot';
        const insideSpan = document.createElement('span');
        bullet.appendChild(insideSpan);
        bullet.onclick = () => pswp.goTo(index);
        el.appendChild(bullet);
        return bullet;
      });

      let prevIndex = -1;
      pswp.on('change', () => {
        if (prevIndex >= 0) {
          bullets[prevIndex].classList.remove('photoswipe-dot-active');
        }
        bullets[pswp.currIndex].classList.add('photoswipe-dot-active');
        prevIndex = pswp.currIndex;
      });
    },
  });
}

export default photoswipe;
